import styled from 'styled-components';

export const Wrapper = styled.div`
    display: flex;
    justify-content: flex-end;
    margin-top: 3px;
    padding: 0 80px;
`;

export const Separator = styled.div`
    width: 350px;
    height: 1px;
    margin-top: 10px;
    margin-bottom: 5px;
    background: #979797;
`;
